module.exports = __webpack_public_path__ + "icomoon.d4bb462111a7bc73aa41.ttf";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/assets/fonts/icomoon.ttf?aa6i4s
// module id = ../../../../../src/assets/fonts/icomoon.ttf?aa6i4s
// module chunks = 11